import React, { useState } from "react";
import "./Modal.css";

/**
 * Confirmation modal for generating a new refresh token for a user.
 * Warns the admin that the old refresh token will be invalidated.
 */
function GenerateKeyModal({ user, onClose, onConfirm, loading }) {
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    setError(null);
    try {
      await onConfirm();
    } catch (err) {
      setError(err.message || "Failed to generate new refresh token.");
    }
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content modal-content--sm"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h2 className="modal-title">Generate New Refresh Token</h2>
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="modal-body">
          {error && <div className="modal-error">{error}</div>}

          <div className="modal-confirm-icon modal-confirm-icon--warning">
            <svg
              width="32"
              height="32"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
            </svg>
          </div>

          <p className="modal-confirm-text">
            Do you want to generate a new refresh token for{" "}
            <strong>{user.name || user.email || user.id}</strong>?
          </p>
          <p className="modal-confirm-warning">
            The existing refresh token will be invalidated. The user will need
            to use the new refresh token for authentication.
          </p>
        </div>

        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleConfirm}
            disabled={loading}
          >
            {loading ? "Generating..." : "Generate New Token"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default GenerateKeyModal;
